import React from "react";

const ExportIcon = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path fillRule="evenodd" clipRule="evenodd" d="M27.734 14.058a1 1 0 0 1-1.414 0L17.003 4.74v18.306a1 1 0 1 1-2 0V4.74l-9.317 9.317a1 1 0 0 1-1.414-1.414l9.893-9.893a2.6 2.6 0 0 1 3.677 0l9.892 9.893a1 1 0 0 1 0 1.414Zm-2.311 15.934a2.6 2.6 0 0 0 2.6-2.6v-6.451a1 1 0 1 0-2 0v6.451a.6.6 0 0 1-.6.6H6.59a.6.6 0 0 1-.6-.6v-6.451a1 1 0 1 0-2 0v6.451a2.6 2.6 0 0 0 2.6 2.6h18.833Z" fill="currentColor" />
    </svg>)
}
export default ExportIcon;